import React, { useMemo } from "react";
import { SlHandbag } from "react-icons/sl";
import { PiSuitcaseRolling } from "react-icons/pi";
import "./IncludedBaggageCompact.scss";

function iconForBullet(text) {
  const t = String(text || "");
  if (t.includes("טרולי")) return SlHandbag;
  if (t.includes("מזוודה")) return PiSuitcaseRolling;
  return PiSuitcaseRolling;
}

function normalizeBullets(bullets) {
  if (!Array.isArray(bullets)) return [];
  return bullets
    .map((s) => String(s).trim())
    .filter((t) => t && !t.includes("ללא כבודה"));
}

/** תצוגה קצרה בשורת מטא — טרולי / מזוודה (+ משקל) בלי כותרת "כבודה" */
function bulletLabelForMetaSubrow(text) {
  const t = String(text || "").trim();
  const kg = t.match(/(\d+(?:\.\d+)?)\s*ק["״']?ג/);
  const weight = kg ? ` ${kg[1]} ק"ג` : "";
  if (t.includes("טרולי")) return `טרולי${weight}`;
  if (t.includes("מזוודה")) return `מזוודה${weight}`;
  return t.replace(/\s*כלולה?\s*/g, " ").trim();
}

/**
 * שורת כבודה כלולה לכרטיסי חיפוש סוכן — אייקונים בלבד (ללא אימוג'י).
 */
export default function IncludedBaggageCompact({
  bullets = null,
  inlineLine = "",
  className = "",
  meta = null,
  /** שורה מתחת למטא (תאריכים / לילות / בסיס) — ללא מסגרת, פריטים בשורה */
  variant = "default",
}) {
  const items = useMemo(() => {
    const fromBullets = normalizeBullets(bullets);
    if (fromBullets.length > 0) return fromBullets;
    const line = String(inlineLine || "").trim();
    if (!line) return [];
    return line
      .split("·")
      .map((s) => s.trim())
      .filter(Boolean);
  }, [bullets, inlineLine]);

  if (items.length === 0) return null;

  const isMetaSubrow = variant === "metaSubrow";
  const isPaymentStack = variant === "paymentStack";

  return (
    <div
      className={[
        "hr-included-baggage-compact",
        isMetaSubrow ? "hr-included-baggage-compact--meta-subrow" : "",
        isPaymentStack ? "hr-included-baggage-compact--payment-stack" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      dir="rtl"
      aria-label="כבודה כלולה"
    >
      {!isMetaSubrow && !isPaymentStack ? (
        <span className="hr-included-baggage-compact__heading">
          <PiSuitcaseRolling className="hr-included-baggage-compact__heading-ico" aria-hidden />
          <span className="hr-included-baggage-compact__heading-text">כבודה</span>
        </span>
      ) : null}
      <ul className="hr-included-baggage-compact__list">
        {items.map((text) => {
          const Ico = iconForBullet(text);
          const label = isMetaSubrow ? bulletLabelForMetaSubrow(text) : text;
          return (
            <li key={text} className="hr-included-baggage-compact__item">
              <Ico className="hr-included-baggage-compact__item-ico" aria-hidden />
              <span className="hr-included-baggage-compact__item-text">{label}</span>
            </li>
          );
        })}
      </ul>
      {meta ? <p className="hr-included-baggage-compact__meta">{meta}</p> : null}
    </div>
  );
}
